import { Link } from 'react-router-dom';
import type { Article } from '@/data/articles/types';
import type { Lang } from '@/data/categories';
import { getArticleShort, getArticleTitle } from '@/data/articles/content';
import { uiContent } from '@/data/ui';

interface Props {
  article: Article;
  lang: Lang;
}

export default function ArticleCard({ article, lang }: Props) {
  const t = uiContent[lang];
  const title = getArticleTitle(article.slug, lang);
  const short = getArticleShort(article.slug, lang);

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition hover:-translate-y-1"
    >
      <div className="relative h-44 w-full overflow-hidden">
        <img
          src={article.image}
          alt={title}
          title={`${title} - AllChinaBuy Spreadsheet`}
          className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-background-50/90 text-primary-700">
          <i className={`${article.icon} text-base`}></i>
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <p className="text-xs font-medium text-secondary-700">{t.categoryLabels[article.category] ?? article.category}</p>
        <h3 className="mt-1.5 text-base font-semibold leading-snug text-foreground-900 group-hover:text-primary-700">
          {title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm text-foreground-600">{short}</p>
        <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold whitespace-nowrap text-primary-600">
          {t.readMore}
          <i className="ri-arrow-right-line text-base"></i>
        </span>
      </div>
    </Link>
  );
}